import { Component, Input } from '@angular/core';
import { DemandeContact } from '../../models/demandeContact';
import { TuiButton, TuiExpand, TuiIcon } from '@taiga-ui/core';
import { TuiAccordion } from '@taiga-ui/kit';
import { DemandeContactRowComponent } from '../demande-contact-row/demande-contact-row.component';

@Component({
  selector: 'app-demande-contact-list',
  standalone: true,
  imports: [
    TuiButton,
    TuiExpand,
    TuiAccordion,
    TuiIcon,
    DemandeContactRowComponent,
  ],
  templateUrl: './demande-contact-list.component.html',
  styleUrl: './demande-contact-list.component.scss',
})
export class DemandeContactListComponent {
  @Input() demandesContactList?: DemandeContact[];
  @Input() afficherPatient?: boolean = false;
  @Input({ required: true }) enCoursDeChargement: boolean = false;
  expanded: boolean = false;
}
